import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";
const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: '31px',
    height: '31px',
  }),
  valueContainer: (base) => ({
    ...base,
    height: '31px',
    padding: '.25rem .5rem',
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '31px',
  }),
};

const State = () => {
  const [stateData, setStateData] = useState([]);
  const [countryDrp, setCountryDrpData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formdata, setFormData] = useState({
    country_id: "101",
  });

  const getCountryDrpData = () => {
    axios.post(API_URL.COUNTRY_LIST, {}).then((res) => {
      setCountryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCountryDrpData(cd);
    });
  };

  const getState = () => {
    axios.post(API_URL.STATE_LIST, { country_id: formdata.country_id }).then(
      (res) => {
        if (res.data.status === 1) {
          setStateData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    );
  };

  const deleteState = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.STATE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = stateData.filter((r) => r.id != row.id);
              setStateData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    getState();
  }, [formdata.country_id]);
  useEffect(() => {
    getCountryDrpData();
  }, []);
  return (
    <>
      <div className="page-header">
        <div className="d-flex align-items-center content-page-header">
          <div className="d-flex align-items-center">
            <h5 className="me-1">State</h5>
            <small className="me-2">({stateData.length})</small>
            <div className="form-group mb-0" style={{ width: "250px" }}>
              <Select
                placeholder="Select Country"
                options={countryDrp}
                value={countryDrp.find((r) => r.value == formdata.country_id)}
                styles={customStyles}
                onChange={(e) =>
                  setFormData({ ...formdata, country_id: e.value })
                }
              />
            </div>
          </div>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link
                  to={"/admin/state/add"}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  State
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "5%" }}>#</th>
                        <th style={{ width: "85%" }}>Name</th>
                        <th style={{ width: "10%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {stateData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td>{row.name}</td>
                            <td className="d-flex justify-content-end gap-3">
                              <Link to={"/admin/state/edit/" + row.id}>
                                <i className="fa fa-edit"></i>
                              </Link>
                                <i className="fa fa-trash-alt" onClick={() => deleteState(row)}></i>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default State;
